import { createContentPropTypes } from '../../../helpers/content';

const content = {
	title: 'Payment details',
	typeLabel: 'Type',
	fromLabel: 'From',
	toLabel: 'To',
	amountLabel: 'Amount',
	refLabel: 'Reference',
	feesLabel: 'Fees',
	paymentDateLabel: 'Payment date',
	createdByLabel: 'Created by',
	createdOnLabel: 'Created on',
	totalAmountLabel: 'Total amount',
	transactions: 'Transactions',
	authorisedBy: 'Authorised by',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
